import React from "react";

const StrongDemand = ({ stats, hasCriterias }) => {
  if (!stats || !stats.percent_not_available || stats.all_results_count === 0) {
    return null;
  }

  const criteriasText = hasCriterias ? "avec ces critères" : "";

  return (
    <div className="strong-demand">
      <span aria-hidden data-icon="s" />
      <p>
        Ne tardez plus pour réserver :
        <strong>
          {` ${stats.percent_not_available} des hôtels ${criteriasText} sont déjà complets `}
        </strong>{" "}
        à vos dates.
      </p>
    </div>
  );
};

export default StrongDemand;
